var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mt-5"},[_c('b-spinner',{staticClass:"mr-1"}),_vm._v(" "+_vm._s(_vm.$t('Loading'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }